module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Inhaltsverzeichnis")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c001"
    }
  }, [_vm._v("Glücksspiel für Gewinner (Gambling)")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c002"
    }
  }, [_vm._v("Kapitel1 | Du, der gewinnende Glücksspieler")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c003"
    }
  }, [_vm._v("Kapitel 2 | Kapitel Zwei - Die Fragen, die Sie sich stellen sollten, bevor Sie spielen")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c004"
    }
  }, [_vm._v("Kapitel3 | Kapitel Zwei - Die wichtigste Frage, die Sie sich stellen sollten, bevor Sie mit dem Glücksspiel beginnen")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c005"
    }
  }, [_vm._v("Kapitel4 | Die Glockenkurve")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel5 | Kapitel Fünf - Kurzfristig Kann Alles Passieren - Und Langfristig Kann Lang Sein.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel6 | Glücksspielsträhnen sind keine echten Strähnen")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel7 | Der Spielertrick")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel8 | Psychische Glücksspiele")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel9 | Was ist wirklich zufällig?")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 10 | Opportunitätskosten des Glücksspiels")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 11 | Können Sie sich das Glücksspiel wirklich leisten?")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 12 | Ihr Bankkonto - in einer modernen Wirtschaft")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 13 | Wessen Banknotenrolle ist größer?")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 14 | Es ist Ihr Geld")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 15 | Geschäftsmäßige Aufzeichnungen führen")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel16 | Wettende Systeme")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 17 | Aufhören, wenn es am schönsten ist?")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 18 | Beschwerden über Comps")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 19 | Gute Wetten sind nicht notwendigerweise Gewinnwetten")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel20 | Poker")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel21 | Blackjack - Teil 1")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 22 | Blackjack - Teil 2")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 23 | Video-Poker")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 24 | Craps")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 25 | Bakkarat")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapital 26 | Roulette")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel27 | Slots")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel28 | Wetten auf Pferderennen")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel29 | Sportwetten")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel30 | Lotto")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wie man mit Arbeitskollegen Lotto spielt, ohne zu klagen oder verklagt zu werden")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel31 | Turniere")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel 32 | Online-Glücksspiel")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kapitel33 | Zusammenfassung von dem, was Sie gelernt haben")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0